module.exports = __webpack_public_path__ + "img/goals.96974ea.png";